import { FC } from 'react';
import { Link } from 'react-router-dom';

import { useUserCompanyList } from 'common/hooks/useUserCompanyList';
import Button from 'components/_core/Button';

import * as routes from '../../../../routes';
import locales from './locales';

const CloseAccountLink: FC = () => {
  const { companies } = useUserCompanyList();

  return (
    <Button
      as={Link}
      icon="heart-broken"
      iconPosition="left"
      to={routes.accountClosure}
      variant="danger"
    >
      {companies.length > 1
        ? locales.closeThisCompanyAccount
        : locales.closeMyCompanyAccount}
    </Button>
  );
};

export default CloseAccountLink;
